import React from "react";
import Footer from "components/NewerHomepage/Footer";
import NavbarV2 from "components/NavbarV2";
import useIntersectionObservers from "hooks/useIntersectionObservers";
import SearchComponent from "components/Search/Search";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { getUrlPath } from "utils/helpers";
import clsx from "clsx";
import SEO from "../seo";

const Layout = ({
	children,
	title,
	image = undefined,
	metaDescription,
	metaTitle,
	ogUrl = undefined,
	slug,
	pageNumber = null,
	disableIndexing = false,
	ogImageUrl = undefined,
	removeMarginFromFooter = false,
	fromHomepage = false,
	hideSearchbar = false,
	isSearch,
	isJobListingPage,
	showNavBar = true,
	showFooter = true,
}) => {
	const { isDesktopSearchExpanded, jobsInStore } = useJobFeedStore();
	const { isIntersecting: showElement, elementRef: footerRef } =
		useIntersectionObservers({ threshold: 0.2, rootMargin: "20px" });
	const path = getUrlPath();
	// add path names to hide footer
	const pathsToCheck = ["/home"];
	return (
		<>
			<SEO
				title={title}
				metaImage={image}
				description={metaDescription}
				metaTitle={metaTitle}
				image={image}
				ogUrl={ogUrl}
				ogImageUrl={ogImageUrl}
				slug={slug}
				pageNumber={pageNumber}
				disableIndexing={disableIndexing}
			/>
			{showNavBar && (
				<NavbarV2 fromHomepage={fromHomepage} hideSearchbar={hideSearchbar} />
			)}
			<main
				className={clsx("relative min-h-screen bg-[#F4F2F6]", {
					"bg-white": isJobListingPage,
				})}
			>
				{isDesktopSearchExpanded && (
					<div className="hidden w-full bg-white p-[16px] md:block">
						<div className="mx-auto max-w-[1040px]">
							<SearchComponent jobs={jobsInStore} isSearchPage={isSearch} />
						</div>
					</div>
				)}
				<div className="border border-transparent md:bg-[#F4F2F6]">
					{children}
				</div>
			</main>
			<div ref={footerRef}>
				{pathsToCheck.some((pathItem) => path !== pathItem) &&
					showElement &&
					showFooter && <Footer removeMargin={removeMarginFromFooter} />}
			</div>
		</>
	);
};

export default Layout;
